module.exports = __webpack_public_path__ + "media/images/ioscor-web-logo_arreglar_LOGUITO-8fd20ea9f3e050cda8f2c4db4ae9886f.png";